export enum DrawType {
    DrawArray,
    DrawArrayInstance,
    DrawElement,
    DrawElementInstance
}